import { useState, useEffect } from 'react';
import API from '../lib/api';

import { Grid, GridCol, Center, Paper } from '@mantine/core';
import StationHeatmap from '../components/StationHeatmap';

export function StationsPage() {
	const [stations, setStations] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchStations = async () => {
			const r = await API.post('station/getCachedStationData');
			if (r.error) {
				console.error(r.error);
				return;
			}
			setStations(r);
			setLoading(false);
		}
		fetchStations();
	}, []);

	if (loading) {
		return <h1>Loading...</h1>;
	}

	return (
		<>
			<Center>
				<Paper w={1000} shadow="sm" p="md" m="md">
					<h1>Stations</h1>
					<Grid p="lg">
						{stations.map((station, index) => (
							<GridCol key={index} span={12} sm={6} md={4}>
								<div>
									<h2>{station.full_name || station.name}</h2>
									<StationHeatmap station={station} />
								</div>
							</GridCol>
						))}
					</Grid>
				</Paper>
			</Center>
		</>
	);
}

/*
return (
		<>
			<Center>
				<Paper w={1000} shadow="sm" p="md" m="md">
					<h1>Stations</h1>
					<List
						itemData={stations}
						itemCount={stations.length}
						height={800}
						itemSize={100}
					>
						{({ index, style }) => (
							<StationHeatmap
								data={stations[index]}
								index={index}
								style={style}
							/>
						)}
					</List>
				</Paper>
			</Center>
		</>
	);
	*/